import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const ApiKeysPage = lazy(() =>
  import('../../pages/admin/api-keys/ApiKeysPage').then((m) => ({
    default: m.ApiKeysPage,
  })),
);

export const Route = createFileRoute('/admin/api-keys')({
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <ApiKeysPage />
    </Suspense>
  ),
});
